// Single source of truth for the "Why choose us" section (WhyChooseUs.vue).
// Every point is meant to be concrete and provable — edit here and the section
// updates automatically. A balanced mix of partnership, craft and delivery.

export interface WhyChooseUsPoint {
  title: string;
  description: string;
}

export const whyChooseUsPoints: WhyChooseUsPoint[] = [
  {
    title: 'Clear, honest communication',
    description:
      'Straight answers, regular updates and no jargon — you always know exactly where your project stands.',
  },
  {
    title: 'A senior team, no hand-offs',
    description:
      'You work directly with the people designing and building your product, not account managers or junior staff.',
  },
  {
    title: 'Design and engineering, together',
    description:
      'One team owns the whole journey, so the product stays cohesive and nothing gets lost between design and code.',
  },
  {
    title: 'Built to last',
    description:
      'Typed, documented and performance-minded from the start, so your product stays fast and easy to evolve.',
  },
  {
    title: 'Fast, focused delivery',
    description:
      'We ship a sharp MVP quickly and iterate on real feedback, with clear timelines instead of open-ended guesswork.',
  },
  {
    title: 'We don’t stop at launch',
    description: 'Monitoring, updates and ongoing improvements keep your product healthy long after it goes live.',
  },
];
